import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";

const options = { role: ROLE.BUSINESS };
const path = "business/transactions";

export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};

export const ExcelList = async () => {
  return await axiosInstance(options).get(`${path}/excel-transaction-list`);
};

export const Details = async (id) => {
  return await axiosInstance(options).get(`${path}/details?o_id=${id}`);
};

export const CreateTransaction = async (values) => {
  return await axiosInstance(options).post(`${path}/create-transaction`, values);
};
